import { ApckPlaceholder } from "../common/placeholder"
import { ApckLogConsole } from "../common/log_console"
import { createUUIDv4 } from '../../util/helpers';
import AjaxUtils from '../../util/ajax_utils';



export const ApckIntegrationValidator = {
    components: {
        'apck-placeholder': ApckPlaceholder,
        'apck-log-console': ApckLogConsole,
    },
    props: {
        integrationIds: {
            type: [Object, String],
            default: () => ({})
        }
    },
    mounted() {
        const cmp = this;
        if (typeof this.integrationIds === 'string') {
            this.integrations = JSON.parse(this.integrationIds);
        } else {
            this.integrations = this.integrationIds;
        }
        // if (this.integrations.jira && this.integrations.jira[0]) {
        //     AjaxUtils.ajax_get({
        //         url: `/integration/test/jira/${this.integrations.jira[0]}/errors`,
        //         success(data) {
        //             if (data.data) {
        //                 cmp.help.jira = data.data;
        //             }
        //         },
        //     });
        // }
    },
    data() {
        return {
            events: {
                jira: [],
            },
            logs: {
                jira: []
            },
            summaries: {
                jira: null,
            },
            // help: {
            //     jira: [],
            // },
            // TODO: Generate buttons for each ID. Needs IDs shown in forms first
            // {'jira': ['id-1', 'id-2']}
            integrations: {},
        }
    },
    computed: {
        showJira() {
            // From truthy to a boolean
            return this.integrations.jira ? true : false;
        },
        jiraEvents() {
            return this.events.jira;
        },
        jiraLogs() {
            return this.logs.jira;
        },
        jiraSummary() {
            return this.summaries.jira ? this.summaries.jira.join(". ") : "";
        }
    },
    methods: {
        addEvent: function (integration, data, logType) {
            if (!data) return;
            if (!logType) logType = 'log_info';
            this.events[integration].push({
                type: logType,
                data: data,
                id: createUUIDv4(),
            });
        },
        clearEvents(integration) {
            this.events[integration] = []
        },
        addLog: function(integration, data, logType) {
            if (!data) return;
            if (!logType) logType = 'log_info';
            this.logs[integration].push({
                type: logType,
                data: data,
                id: createUUIDv4(),
            });
        },
        clearLog(integration) {
            this.logs[integration] = [];
        },
        getLogs(integration, integrationId) {
            const cmp = this;
            cmp.clearLog(integration);
            cmp.addLog(integration, `Begin logs for ${integration}. ID = ${integrationId}`, 'log_success');

            AjaxUtils.ajax_get({
                url: `/integration/test/${integration}/${integrationId}/logs`,
                success(data) {
                    if (data.logs) {
                        data.logs.forEach(l => cmp.addLog(integration, l));
                        cmp.addLog(integration, `End logs for ${integration}. ID = ${integrationId}`, "log_success")
                    } else {
                        cmp.addLog(integration, `No logs received`, 'log_warning');
                    }
                },
                fail(data, status) {
                    const e = data ? data : `AppCheck HTTP Error: ${status}`;
                    cmp.addLog(integration, `${integration}. ID: ${integrationId}`, 'log_error');
                    cmp.addLog(integration, `Error: ${e}`, 'log_error');
                },
                opts: { flash_form_errors: false, flash_404_errors: false },
            });
        },
        clearLogs(integration, integrationId) {
            const cmp = this;
            cmp.clearLog(integration);
            AjaxUtils.ajax_get({
                url: `/integration/test/${integration}/${integrationId}/logs-clear`,
                success(data) {
                    cmp.addLog(integration, `${integration}. ID: ${integrationId}. Logs cleared`, 'log_success')
                },
                fail(data, status) {
                    const e = data ? data : `AppCheck HTTP Error: ${status}`;
                    cmp.addLog(integration, `${integration}. ID: ${jiraId}`, 'log_error')
                    cmp.addLog(integration, `Error: ${e}`, 'log_error');
                },
                opts: { flash_form_errors: false, flash_404_errors: false },
            })
        },
        testJira(jiraId) {
            const cmp = this;
            const integration = 'jira';
            const POLL_COUNT = 10;

            cmp.clearEvents(integration);
            cmp.addEvent(integration, 'Starting JIRA test. ID = ' + jiraId, "log_info")
            const urls = [
                ["Attempting to create a JIRA issue", "/integration/test/jira/" + jiraId + "/create-issue"],
                ["Attempting to create a comment on the JIRA issue", "/integration/test/jira/" + jiraId + "/create-comment"],
                ["Attempting to update the JIRA issue", "/integration/test/jira/" + jiraId + "/update-issue"],
                ["Attempting to update the JIRA comment", "/integration/test/jira/" + jiraId + "/update-comment"],
                ["Validating mapped issue transitions", "/integration/test/jira/" + jiraId + "/update-issue-transitions"],
                ["Validating mapped issue priorities", "/integration/test/jira/" + jiraId + "/update-issue-priorities"],
                // required so that there is an update webhook fired in jira
                ["Running comment update", "/integration/test/jira/" + jiraId + "/update-comment"],
            ];

            const issuePoll = (i) => {
                if (i > POLL_COUNT) {
                    cmp.addEvent(integration, "JIRA incoming issue webhook not set correctly", "log_error");
                    cmp.summaries.jira = ["Test completed with errors. Your configuration within AppCheck is correct, however, your issue updated webhook within JIRA is incorrectly setup."]
                    return 
                }
                cmp.addEvent(integration, `[${i}/${POLL_COUNT}] Checking for JIRA incoming issue webhook`, "log_info");
                AjaxUtils.ajax_get({
                    url: "/integration/test/jira/" + jiraId + "/check-issue",
                    success(data) {
                        if (data.error) {
                            if (i+1 > POLL_COUNT) {
                                // If this is the last one, print out the logs on our integration
                                cmp.addEvent(integration, "Begin existing logs messages", "log_warning")
                                data.logs.forEach((l, i) => cmp.addEvent(integration, `[${i+1}/${data.logs.length}] ${l}`, "log_info"))
                                cmp.addEvent(integration, "End existing log message", "log_warning");
                                cmp.summaries.jira = data.cause ? data.cause : ["Test completed with errors. AppCheck was unable to automatically determine the cause for the error. Your configuration is potentially incorrect. For more troubleshooting steps, visit the FAQ."];
                            }
                            setTimeout(() => issuePoll(i+1), 5000);
                            return;
                        }
                        cmp.addEvent(integration, "Incoming issue webhook found. Relevant log messages:", "log_success");
                        data.logs.forEach((l) => cmp.addEvent(integration, l, "log_info"))
                        cmp.addEvent(integration, data.message, "log_success");

                        cmp.addEvent(integration, "All tests completed", "log_success");
                        cmp.summaries.jira = ["All tests completed successfully. Your integration is setup correctly."];
                    },
                    fail(data, status) {
                        const e = data ? data : `AppCheck HTTP Error: ${status}`;
                        cmp.addEvent(integration, `Error: ${e}`, 'log_error');
                        cmp.addEvent(integration, 'Stopping tests', 'log_error');
                        cmp.$flash({type: 'error', message: 'Tests failed'});
                        cmp.summaries.jira = data.cause ? data.cause : ["Test completed with errors. AppCheck was unable to automatically determine the cause for the error. Your configuration is potentially incorrect. For more troubleshooting steps, visit the FAQ."];
                    },
                    opts: { flash_form_errors: false, flash_404_errors: false },
                })
            }
            const commentPoll = (i) => {
                if (i > POLL_COUNT) {
                    cmp.addEvent(integration, "JIRA incoming comment webhook not set correctly", "log_error");
                    cmp.summaries.jira = ["Test completed with errors. Your configuration within AppCheck is correct, however, your comment updated webhook within JIRA is incorrectly setup."]
                    return 
                }
                cmp.addEvent(integration, `[${i}/${POLL_COUNT}] Checking for JIRA incoming comment webhook`, "log_info");
                AjaxUtils.ajax_get({
                    url: "/integration/test/jira/" + jiraId + "/check-comment",
                    success(data) {
                        if (data.error) {
                            if (i+1 > POLL_COUNT) {
                                // If this is the last one, print out the logs on our integration
                                cmp.addEvent(integration, "Begin existing logs messages", "log_warning")
                                data.logs.forEach((l, i) => cmp.addEvent(integration, `[${i+1}/${data.logs.length}] ${l}`, "log_info"))
                                cmp.addEvent(integration, "End existing log message", "log_warning");
                                cmp.summaries.jira = data.cause ? data.cause : ["Test completed with errors. AppCheck was unable to automatically determine the cause for the error. Your configuration is potentially incorrect. For more troubleshooting steps, visit the FAQ."];
                            }
                            setTimeout(() => commentPoll(i+1), 5000);
                            return;
                        }
                        cmp.addEvent(integration, "Incoming comment webhook found. Relevant log messages:", "log_success");
                        data.logs.forEach((l) => cmp.addEvent(integration, l, "log_info"))
                        cmp.addEvent(integration, data.message, "log_success");
                        
                        // Successfully setup. Run the issue status poll
                        issuePoll(1);
                    },
                    fail(data, status) {
                        const e = data ? data : `AppCheck HTTP Error: ${status}`;
                        cmp.addEvent(integration, `Error: ${e}`, 'log_error');
                        cmp.addEvent(integration, 'Stopping tests', 'log_error');
                        cmp.$flash({type: 'error', message: 'Tests failed'});
                    },
                    opts: { flash_form_errors: false, flash_404_errors: false },
                })
            }
            const makeRequest = (i) => {
                cmp.addEvent(integration, urls[i][0], "log_info");
                AjaxUtils.ajax_get({
                    url: urls[i][1],
                    success(data) {
                        cmp.addEvent(integration, data.message, data.error ? "log_error" : "log_success");
                        if (data.error) {
                            cmp.summaries.jira = data.cause ? data.cause : ["Test completed with errors. AppCheck was unable to automatically determine the cause for the error. Your configuration is potentially incorrect. For more troubleshooting steps, visit the FAQ."];
                        }

                        // Add a catchcase here because we don't want the user resubmitting the form with empty values
                        // for the test data. Once this component is fully moved to VueJS this can be removed but for
                        // now whilst it is tied to webgui we must do this instead.
                        // Additionally, webgui does not provide IDs on its form elements (used everywhere) so the
                        // solution for now is to assume that no other elements have this name within the form
                        if (i === 0 || i === 1) {
                            if (data.issue_id) {
                                document.getElementsByName("integrations_jira_test_issue_id").forEach(e => e.value = data.issue_id);
                            }
                            if (data.comment_id) {
                                document.getElementsByName("integrations_jira_test_comment_id").forEach(e => e.value = data.comment_id);
                            }
                        }

                        if (!data.error) {
                            if (i < urls.length - 1) {
                                makeRequest(i + 1)
                            } else {
                                // AppCheck -> JIRA tests complete. Now start the JIRA -> AppCheck
                                commentPoll(1);
                            }
                        }
                    },
                    fail(data, status) {
                        const e = data ? data : `AppCheck HTTP Error: ${status}`;
                        cmp.addEvent(integration, `Error: ${e}`, 'log_error');
                        cmp.addEvent(integration, 'Stopping tests', 'log_error');
                        cmp.$flash({type: 'error', message: 'Tests failed'});
                        cmp.summaries.jira = data.cause ? data.cause : ["Test completed with errors. AppCheck was unable to automatically determine the cause for the error. Your configuration is potentially incorrect. For more troubleshooting steps, visit the FAQ."];
                    },
                    opts: { flash_form_errors: false, flash_404_errors: false },
                });
            };

            makeRequest(0);
        },
    },
    template: `
        <div>
            <apck-tabs>
                <apck-tab title="JIRA" :active="true" v-if="showJira">
                    <apck-tabs>
                        <apck-tab title="Test" :active="true">
                            <div style='margin: 5px'>
                                <apck-button 
                                    v-for="id in integrationIds.jira"
                                    :key="id"
                                    href="javascript:" 
                                    :title="'Run '+id" 
                                    value="Run Integration" 
                                    class="btn-secondary" 
                                    :handler="() => testJira(id)" 
                                />
                            </div>
                            <div style="margin-bottom: 15px; border: 1px solid #CDCDCD; margin-top: 10px; padding: 10px !important; text-align: left;">
                                <h4>
                                    <i v-if="!this.jiraSummary" class="fa fa-info-circle" style="color: #2585A4" />
                                    <i v-else-if="this.jiraSummary.includes('incorrect') || this.jiraSummary.includes('custom')" class="fa fa-exclamation-circle" style="color: #c43c35" />
                                    <i v-else class="fa fa-check-circle" style="color: #46a546" />
                                    Test Summary
                                </h4>
                                <p v-if="this.jiraSummary">{{ this.jiraSummary }}</p>
                                <p v-else>Your test summary will appear here once the test is complete</p>
                            </div>
                            <div class="test-integration-log">
                                <apck-placeholder
                                    v-if="jiraEvents.length === 0"
                                    title="No test logs yet"
                                    description="Test logs will start to appear here once a test has started"
                                />
                                <apck-log-console :events="jiraEvents" v-if="jiraEvents.length" style="border: 1px solid #CDCDCD" />
                            </div>
                        </apck-tab>
                        <apck-tab title="Logs">
                            <div style='margin: 5px'>
                                <apck-button
                                    v-for="id in integrationIds.jira"
                                    :key="id" 
                                    href="javascript:"
                                    :title="id+' Logs'"
                                    value="Get Logs"
                                    class="btn-secondary"
                                    :handler="() => getLogs('jira', id)"
                                />
                            </div>
                            <div style='margin: 5px'>
                                <apck-button
                                    v-for="id in integrationIds.jira"
                                    :key="id"
                                    href="javascript:" 
                                    :title="'Clear '+id"
                                    value="Clear Logs"
                                    class="btn-negative" 
                                    :handler="() => clearLogs('jira', id)" 
                                />
                            </div>
                            <div class="test-integration-log">
                                <apck-placeholder
                                    v-if="jiraLogs.length === 0"
                                    title="No logs loaded"
                                    description="Select an integration to load logs"
                                />
                                <apck-log-console :events="jiraLogs" v-if="jiraLogs.length" style="border: 1px solid #CDCDCD" />
                            </div>
                        </apck-tab>
                        <apck-tab v-if="0" title="Help" style="padding: 5px;">
                            <h4>Common Errors</h4>
                            <br />
                            <ul style="list-style: none">
                                <li v-for="h in this.help.jira" style="margin-bottom: 30px">
                                    <strong>Example:</strong>&nbsp;<pre style="display: inline-block">{{ h.example }}</pre>
                                    <strong>Explanation:</strong> {{ h.cause }}
                                </li>
                            </ul>
                        </apck-tab>
                    </apck-tabs>
                </apck-tab>
            </apck-tabs>
        </div>
    `
}